import React, { useState, useEffect } from 'react';
import '../Dropdown/Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

export default function AutorizarNotaIndividual() {
  const [notasPendentes, setNotasPendentes] = useState([]);
  const [notaSelecionada, setNotaSelecionada] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    carregarNotasPendentes();
  }, []);

  const apiCall = async (endpoint, options = {}) => {
    const urls = [
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`
    ];

    for (const url of urls) {
      try {
        console.log(`Tentando conectar em: ${url}`);
        const token = getAuthToken();
        const optionsWithAuth = { ...options, headers: { ...(options.headers || {})} };
        if (token) optionsWithAuth.headers['Authorization'] = 'Bearer ' + token;
        const response = await fetch(url, optionsWithAuth);
        if (response.ok) {
          console.log(`✅ Sucesso em: ${url}`);
          return await response.json();
        }
        const errorText = await response.text();
        console.log(`❌ Falha em: ${url} - Status: ${response.status} - ${errorText}`);
        if (url === urls[urls.length - 1]) {
          throw new Error(errorText || `Erro HTTP ${response.status}`);
        }
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
        if (url === urls[urls.length - 1]) {
          throw error;
        }
      }
    }
  };

  const carregarNotasPendentes = async () => {
    try {
      setLoading(true);
      setErro('');
      const data = await apiCall('NotaFiscal/pendentes');
      const lista = Array.isArray(data) ? data : [];
      setNotasPendentes(lista);
    } catch (err) {
      console.error('Erro ao carregar notas pendentes:', err);
      setErro('Erro ao carregar notas pendentes. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };

  const handleAutorizar = async (e) => {
    e.preventDefault();
    
    if (!notaSelecionada) {
      setErro('Selecione uma nota fiscal para autorizar.');
      return;
    }

    try {
      setLoading(true);
      setErro('');
      setMensagem('');

      // Buscar o VendaId da nota selecionada
      const nota = notasPendentes.find(n => 
        (n.id || n.Id || n.notaId) === parseInt(notaSelecionada)
      );

      if (!nota) {
        throw new Error('Nota fiscal não encontrada.');
      }

      const vendaId = nota.vendaId || nota.VendaId || nota.Venda?.Id || nota.Venda?.id;
      
      if (!vendaId) {
        throw new Error('VendaId não encontrado para esta nota fiscal.');
      }

      const resultado = await apiCall(`NotaFiscal/autorizar/${vendaId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (resultado.success) {
        setMensagem(`✅ Nota Fiscal #${resultado.notaFiscal.numero} autorizada com sucesso!`);
        setNotaSelecionada('');
        // Recarregar lista de pendentes
        setTimeout(() => {
          carregarNotasPendentes();
          setMensagem('');
        }, 3000);
      } else {
        throw new Error(resultado.message || 'Erro ao autorizar nota fiscal.');
      }
    } catch (err) {
      console.error('Erro ao autorizar nota:', err);
      setErro(`Erro ao autorizar: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '800px',
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          color: 'rgb(235, 133, 0)', 
          fontSize: '28px', 
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'center'
        }}>
          Autorizar Nota Fiscal - Individual
        </h1>
        
        <p style={{ 
          textAlign: 'center', 
          color: '#666', 
          marginBottom: '30px',
          fontSize: '14px'
        }}>
          Selecione uma nota fiscal pendente para autorizar no SEFAZ
        </p>

        {erro && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #ef5350'
          }}>
            {erro}
          </div>
        )}

        {mensagem && (
          <div style={{
            background: '#e8f5e9',
            color: '#2e7d32',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #66bb6a'
          }}>
            {mensagem}
          </div>
        )}

        <form onSubmit={handleAutorizar}>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ 
              display: 'block',
              marginBottom: '10px',
              color: '#333',
              fontWeight: '500',
              fontSize: '15px'
            }}>
              Nota Fiscal Pendente:
            </label>
            <select
              value={notaSelecionada}
              onChange={(e) => setNotaSelecionada(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                outline: 'none',
                cursor: 'pointer'
              }}
              required
            >
              <option value="">-- Selecione uma Nota Fiscal --</option>
              {notasPendentes.map((nota) => {
                const id = nota.id || nota.Id || nota.notaId;
                const numero = nota.numero || nota.Numero || '';
                const nomeCliente = nota.nomeCliente || nota.NomeCliente || nota.Cliente?.Nome || '';
                const valor = nota.valor || nota.Valor || nota.valorTotal || nota.ValorTotal || 0;
                
                return (
                  <option key={id} value={id}>
                    NF #{numero} - {nomeCliente} - R$ {Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </option>
                );
              })}
            </select>
            
            {notasPendentes.length === 0 && !loading && (
              <p style={{ 
                marginTop: '10px', 
                color: '#666', 
                fontSize: '14px',
                fontStyle: 'italic'
              }}>
                Nenhuma nota fiscal pendente de autorização.
              </p>
            )}
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '15px', 
            justifyContent: 'flex-end',
            marginTop: '30px'
          }}>
            <button
              type="button"
              onClick={() => window.history.back()}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                background: 'white',
                color: '#666',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.background = 'white'}
            >
              Voltar
            </button>
            
            <button
              type="submit"
              disabled={!notaSelecionada || loading}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: 'none',
                borderRadius: '6px',
                background: notaSelecionada && !loading ? 'rgb(235, 133, 0)' : '#ccc',
                color: 'white',
                cursor: notaSelecionada && !loading ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (notaSelecionada && !loading) {
                  e.target.style.background = 'rgb(208, 116, 0)';
                }
              }}
              onMouseLeave={(e) => {
                if (notaSelecionada && !loading) {
                  e.target.style.background = 'rgb(235, 133, 0)';
                }
              }}
            >
              {loading ? 'Autorizando...' : 'Autorizar Nota Fiscal'}
            </button>
          </div>
        </form>
      </div>

      <LoadingOverlay isLoading={loading} message="Processando autorização..." />
    </div>
  );
}
